







import OpenStreetMapLayer from '@/components/maps/OpenStreetMapLayer.vue';
import {GeoJsonObject} from 'geojson';
import {CircleMarker, geoJSON, GeoJSONOptions, LatLngBounds, LatLngExpression} from 'leaflet';
import {Component, Prop, Vue} from 'vue-property-decorator';
import {LCircleMarker, LGeoJson, LMap} from 'vue2-leaflet';

@Component({components: {LGeoJson, LMap, OpenStreetMapLayer, LCircleMarker}})
export default class PlaceMap extends Vue {
  @Prop({type: Number})
  public readonly latitude: number;

  @Prop({type: Number})
  public readonly longitude: number;

  @Prop({type: Object})
  public readonly geoJson: GeoJsonObject;

  protected get bounds(): LatLngBounds {
    return  geoJSON(this.geoJson).getBounds();
  }

  protected get polygon(): GeoJSONOptions {
    return {
      style: () => ({
        weight: 3,
        color: '#0000ff',
        opacity: 0.75,
        fillColor: '#0000ff',
        fillOpacity: 0.3,
      }),
      pointToLayer(feature, latlng: LatLngExpression): CircleMarker {
        return new CircleMarker(
            latlng,
            {
              radius: 8,
              fillColor: '#0000ff',
              color: '#0000ff',
              weight: 3,
              opacity: 0.75,
              fillOpacity: 0.3,
            },
        );
      },
    };
  }
}
